import React from "react";
import PropTypes from "prop-types";

import JustifiedGrid from "core/JustifiedGrid";
import SubmissionsGridItemContent from "./SubmissionsGridItemContent";

const PendingGroupGrid = ({ data }) => {
    const items = data.map((data, index) => (
        <SubmissionsGridItemContent key={index} data={data} />
    ));

    const itemRatios = data.map(data => data.aspectRatio);

    return <JustifiedGrid items={items} itemRatios={itemRatios} />;
};

PendingGroupGrid.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default PendingGroupGrid;
